/* istanbul ignore file */

import type { MutableRefObject } from 'react';
import { useEffect, useState } from 'react';

export const useCarouselIntersections = (
  wrapper: MutableRefObject<HTMLElement | null>,
  elements: MutableRefObject<(HTMLElement | null)[]>,
  isLoading?: boolean,
) => {
  const [intersections, setIntersections] = useState<IntersectionObserverEntry[]>([]);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    if (wrapper.current && elements.current) {
      const intersectionOptions = {
        root: wrapper.current as Element,
        rootMargin: '0px',
        threshold: 1.0,
      };

      elements.current.forEach((element, index) => {
        const addIntersectionEntry = (entries: IntersectionObserverEntry[]) => {
          if (entries[0]) {
            setIntersections((previous) => {
              previous[index] = entries[0];
              return [...previous];
            });
          }
        };
        const observer = new IntersectionObserver(addIntersectionEntry, intersectionOptions);
        observer.observe(element as Element);
        observers.push(observer);
      });
    }

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [wrapper, elements, isLoading]);

  return intersections;
};
